import { render, staticRenderFns } from "./StopCustomFieldModal.vue?vue&type=template&id=596cbc12&scoped=true&"
import script from "./StopCustomFieldModal.vue?vue&type=script&lang=js&"
export * from "./StopCustomFieldModal.vue?vue&type=script&lang=js&"
import style0 from "./StopCustomFieldModal.vue?vue&type=style&index=0&id=596cbc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596cbc12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596cbc12')) {
      api.createRecord('596cbc12', component.options)
    } else {
      api.reload('596cbc12', component.options)
    }
    module.hot.accept("./StopCustomFieldModal.vue?vue&type=template&id=596cbc12&scoped=true&", function () {
      api.rerender('596cbc12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BookingFields/components/StopCustomFieldModal.vue"
export default component.exports